import { SERIF_FONTS } from 'app/app.quotion.co/[isEU]/(dashboard)/site/[subdomain]/(shrinked-sidebar)/design/all/constants';

export const SANS_SERIF_FONT_FALLBACKS = [
  'system-ui',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  // 'Arial',
  '"Noto Sans"',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"',
];

export const SERIF_FONT_FALLBACKS = [
  'ui-serif',
  'Georgia',
  'Cambria',
  '"Times New Roman"',
  'Times',
  'serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"',
];

export function getFontFamily(font?: string | null) {
  let fonts = [font ? `"${font}"` : '"Inter"', ...SANS_SERIF_FONT_FALLBACKS];
  if (font && SERIF_FONTS.includes(font)) {
    fonts = [`"${font}"`, ...SERIF_FONT_FALLBACKS];
  }
  return fonts.join(',');
}
